import React from 'react';

import Browser from '@wetransfer/concorde-browser';
import I18n from '@module/i18n';

import Cookie from '@wetransfer/concorde-cookie';

import FeatureFlagsHelper from '@app/helper/featureflags';
import AdvertGallery from '@app/page/advertise/gallery';
import AdvertiseGuidelines from '@app/page/advertise/guidelines';
import AdvertiseHome from '@app/page/advertise/home';
import Store from '@app/store';

import ContactSales from '@component/form/contactsales';
import Icon from '@component/icon';

export default {
  getItems() {
    let aboutUseTrk = 'WT201610_AboutPlus';
    if (FeatureFlagsHelper.unlimitedTransfers) {
      aboutUseTrk = 'WT201806_AboutPlus';
    }

    const homeItem = { path: '/', name: I18n.t('navigation.home.name') };
    const helpItem = {
      name: I18n.t('navigation.help.name'),
      path: '/help',
      items: [],
    };
    const aboutItem = {
      path: '/about',
      name: I18n.t('navigation.about_us.items.about'),
    };
    const plusItem = {
      path: '/plus',
      trk: aboutUseTrk,
      name: I18n.t('navigation.about_us.items.plus'),
    };
    const productsItem = {
      path: '/products',
      name: I18n.t('navigation.about_us.items.products'),
    };
    const advertiseItem = {
      path: '/advertise',
      name: I18n.t('navigation.about_us.items.advertise'),
    };
    const transfersItem = {
      path: '/transfers',
      name: I18n.t('navigation.user.items.transfers'),
    };
    const contactsItem = {
      path: '/contacts',
      name: I18n.t('navigation.user.items.contacts'),
    };
    const profileItem = {
      path: '/profile',
      name: I18n.t('navigation.user.items.profile'),
    };
    const accountItem = {
      path: '/account',
      name: I18n.t('navigation.user.items.account'),
    };
    const signoutItem = {
      path: '/signout',
      name: I18n.t('navigation.sign_out'),
    };
    const teamsItem = {
      path: '/team',
      name: I18n.t('navigation.user.items.teams'),
    };

    const uploadItem = {
      path: '/upload',
      name: I18n.t('transfer.buttons.new_transfer'),
    };

    // Default
    const { user, account } = Store.getState();
    const plusCookie = parseInt(Cookie.get('wt_plus'), 10) === 1;
    let loginItem = {
      name: plusCookie
        ? I18n.t('navigation.signin.name')
        : I18n.t('navigation.got_plus.name'),
      path: '/sign-in',
      items: [],
    };

    // If the user is logged in, the menu is slightly different.
    if (user.loggedIn) {
      // default profile picture
      let avatarThumbnail = user.defaults.profile_picture_thumbnail_url;

      // If available in user
      if (user.profile_picture && user.profile_picture.thumbnail_url) {
        avatarThumbnail = user.profile_picture.thumbnail_url;
      }

      const items = [transfersItem, contactsItem, profileItem, accountItem];
      // Add teams item
      if (FeatureFlagsHelper.hasTeams) {
        items.splice(3, 0, teamsItem);
      }

      loginItem = {
        name: account.subdomain_name || I18n.t('navigation.signed_in.name'),
        image: avatarThumbnail,
        items,
        notificationDetails: ['onboarding_success', 'already_signed_in'],
        hasChannelName: Boolean(account.subdomain_name),
      };
    }

    // If the user is on mobile (a different structure is used in this case)
    if (Browser.isMobile) {
      if (user.loggedIn) {
        loginItem.name = '';
        loginItem.items.push(signoutItem);
      }

      aboutItem.name = I18n.t('navigation.about_us.name_1_2019');

      return [
        {
          id: 'hamburger',
          component: Icon,
          options: { type: 'Hamburger' },
          items: [
            homeItem,
            uploadItem,
            helpItem,
            aboutItem,
            productsItem,
            plusItem,
            advertiseItem,
          ],
        },
        {
          id: 'logo',
          component: Icon,
          options: { type: 'Logo', shadow: true, width: 44 },
          items: [],
          path: '/',
        },
        {
          id: 'login',
          ...loginItem,
        },
      ];
    }

    // This is the expandable main nav
    return [
      helpItem,
      {
        name: I18n.t('navigation.about_us.name_1_2019'),
        items: [aboutItem, productsItem, plusItem, advertiseItem],
      },
      loginItem,
    ];
  },

  getAdvertisePageItems() {
    const downloadIcon = (
      <Icon
        type="DownloadSmall"
        className="verticalnav__icon"
        color="#409FFF"
      />
    );

    const items = [
      {
        href: '/advertise',
        label: I18n.t('page.advertise.nav.home'),
        component: AdvertiseHome,
      },
      {
        href: '/advertise/guidelines',
        label: I18n.t('page.advertise.nav.guidelines'),
        component: AdvertiseGuidelines,
        hiddenOnMobile: true,
      },
      {
        href: '/advertise/gallery',
        label: I18n.t('page.advertise.nav.gallery'),
        component: AdvertGallery,
        hiddenOnMobile: true,
      },
      {
        href: '/advertise/contact',
        label: I18n.t('page.advertise.nav.contact'),
        component: ContactSales,
        className: 'verticalnav__item--is-without-separator',
      },
      {
        label: I18n.t('page.advertise.nav.resources'),
        className: 'verticalnav__item--is-without-separator',
      },
      {
        href: '/docs/advertising/wetransfer-safearea.zip',
        label: I18n.t('page.advertise.nav.download_mockup'),
        icon: downloadIcon,
        external: true,
        hiddenOnMobile: true,
      },
      {
        href: '/docs/advertising/wetransfer-html5api.zip',
        label: I18n.t('page.advertise.nav.download_dev_toolkit'),
        icon: downloadIcon,
        external: true,
        hiddenOnMobile: true,
        className: 'verticalnav__item--is-without-separator',
      },
    ];

    return items;
  },

  getBackButtonItem(name, path) {
    return [{ name, path, backButton: true }];
  },

  getNotifications() {
    return {
      onboarding: { name: 'onboarding_success' },
      signin: { name: 'already_signed_in' },
    };
  },
};
